'use strict';
// Helper method to test whether page is open in page designer UI
// Checks parent URL for page designer address
// If found, adds class 'is-page-designer-ui' to the current document body
var pathname = window.location.pathname;
var queries = window.location.search;
if (pathname.includes("__SYSTEM__Page-Show") && queries.includes("mode=EDIT")) {
    window.document.body.classList.add('is-page-designer-ui');
}